/**
 * Accounts-receivable and revenue financial-control ids (ALC-4534), in catalog order. Only the AR
 * domain edits this file (the AP list lives in `ap.ts`).
 */
export const AR_FINANCIAL_CONTROL_IDS = [
  'AR01',
  'AR02',
  'AR03',
  'AR04',
  'AR05',
  'AR06',
  'AR07',
  'AR08',
] as const;

/**
 * AR03's diagnostic feed ids (decision D12, ALC-4537), declared once so services and web never
 * drift on the string literal — a rename on one side would otherwise silently make the other
 * side read every feed as ABSENT.
 */
export const AR03_DIAGNOSTIC_SOURCES = ['AR03_MILESTONE_EVIDENCE', 'AR03_USAGE_RECORD'] as const;
export type Ar03DiagnosticSource = (typeof AR03_DIAGNOSTIC_SOURCES)[number];
